import { render, staticRenderFns } from "./btnAccess.vue?vue&type=template&id=e08011ba&scoped=true"
import script from "./btnAccess.vue?vue&type=script&lang=js"
export * from "./btnAccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e08011ba",
  null
  
)

export default component.exports